import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const StripeConnectRefresh = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Tenta abrir deep link do app para refresh
    const openDeepLink = () => {
      // Detecta se está em mobile
      const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
      
      if (isMobile) {
        // Tenta abrir deep link do app
        const deepLink = 'ufokko://stripe-connect/refresh';
        
        // Tenta abrir o app via deep link
        window.location.href = deepLink;
        
        // Se não conseguir abrir após 2 segundos, mostra mensagem
        setTimeout(() => {
          // Verifica se ainda está na página (app não abriu)
          if (document.hasFocus()) {
            // Mostra mensagem para retornar ao app manualmente
            alert('Por favor, retorne ao app para continuar o onboarding.');
            navigate('/');
          }
        }, 2000);
      } else {
        // Desktop - mostra mensagem
        alert('Por favor, abra o app para continuar o onboarding.');
        navigate('/');
      }
    };

    openDeepLink();
  }, [navigate]);

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-blue-100 to-blue-50 dark:from-[#0F1629] dark:via-[#1A2332] dark:to-[#0F1629] flex items-center justify-center p-4">
      <div className="bg-white dark:bg-gray-800 rounded-2xl shadow-2xl p-8 max-w-md w-full text-center">
        <div className="mb-6">
          <div className="w-16 h-16 bg-yellow-100 dark:bg-yellow-900 rounded-full flex items-center justify-center mx-auto mb-4">
            <svg
              className="w-8 h-8 text-yellow-600 dark:text-yellow-400"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
              />
            </svg>
          </div>
          <h1 className="text-2xl font-bold text-gray-900 dark:text-white mb-2">
            Continue o Onboarding
          </h1>
          <p className="text-gray-600 dark:text-gray-400">
            Você será redirecionado para o app em instantes...
          </p>
        </div>
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary mx-auto"></div>
      </div>
    </div>
  );
};

export default StripeConnectRefresh;
